import { useTranslation } from 'react-i18next';
import { useSortable } from '@dnd-kit/sortable';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { CSS } from '@dnd-kit/utilities';
import { DEFAULT_LANGUAGE } from '../utils/localeUtils';

function SortableItemCast({ artist, removeArtist, updateArtistRole, selectedLanguage }) {
  const { t } = useTranslation();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: artist.id,
  });

  const [roles, setRoles] = useState({
    ro: artist.role || '',
    en: artist.role_en || '',
    de: artist.role_de || '',
    hu: artist.role_hu || '',
  });

  useEffect(() => {
    setRoles({
      ro: artist.role || '',
      en: artist.role_en || '',
      de: artist.role_de || '',
      hu: artist.role_hu || '',
    });
  }, [artist]);

  const handleRoleChange = (e) => {
    const newValue = e.target.value;
    setRoles((prev) => ({
      ...prev,
      [selectedLanguage]: newValue,
    }));
    updateArtistRole(artist.id, newValue, selectedLanguage);
  };

  const role = roles[selectedLanguage] || '';

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    opacity: isDragging ? 0.6 : 1,
    cursor: 'grab',
  };

  return (
    <ListItem ref={setNodeRef} style={style} divider>
      <ListItemAvatar {...attributes} {...listeners} sx={{ display: 'flex', alignItems: 'center' }}>
        <DragIndicatorIcon sx={{ mr: 1, cursor: 'grab' }} />
        <Avatar src={artist.profile_image_url} sx={{ mr: 2 }} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {artist.label}
          </Typography>
        }
        secondary={
          <TextField
            size="small"
            variant="standard"
            placeholder={t('enterRole')}
            value={role}
            onChange={handleRoleChange}
            sx={{ mt: 0.5, minWidth: 120 }}
          />
        }
      />
      <ListItemSecondaryAction>
        {selectedLanguage === DEFAULT_LANGUAGE && (
          <IconButton onClick={() => removeArtist(artist.id)} edge="end" aria-label="delete">
            <DeleteIcon />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default SortableItemCast;
